import { useTranslation } from "react-i18next";
import { getNewSentRequestsFilter } from "../../../../../common/queries";
import EntityTable from "../../../../common/tables/EntityTable";
import useMissionRequestsColumns from "../../../../../hooks/useMissionRequestsColumns";
import { useMemo } from "react";
import { useStation } from "../../../../../providers/StationProvider";

export default function NewRequestsSection(props) {
  const { onRowClick } = props;
  const { t } = useTranslation();
  const { station } = useStation();
  const columns = useMissionRequestsColumns();
  const filter = useMemo(() => getNewSentRequestsFilter(station), [station]);

  return !!station ? (
    <EntityTable
      tableId="new_requests_section_sent"
      type="MissionRequest"
      onRowClick={onRowClick}
      columns={columns}
      filter={filter}
      emptyStateTitle={t("missionRequests:newRequestsSection:emptyStateTitle")}
      emptyStateDescription={t("missionRequests:newRequestsSection:emptyStateDescription")}
      sortDescendingByDefault
      xs={12}
    />
  ) : null;
}

